<template>
  <ProjectsSection ref="projects"></ProjectsSection>
</template>

<script>
  import ProjectsSection from "./ProjectsSection.vue";
  import BeforeRouteEnter from "./BeforeRouteEnter.js";

  export default {
    name: "ProjectsWrapper",
    components: {
      ProjectsSection,
    },
    beforeRouteEnter: BeforeRouteEnter,
  };
</script>
